if ($('#SimilarItemsTemplate').length) {

  var items = [];
  var item = {};
  var data = {};
  var similarItems = $('#similar-items');
  var source = $('#SimilarItemsTemplate').html();
  var template = Handlebars.compile(source);
   
  const body = {
    // "isbns": "9781579656201"
    "isbns": similarItems.attr('data-isbns').split(',')
  };
  
  const settings = {
      "async": true,
      "crossDomain": true,
      "url": "https://api.wkmhb.com/external/related-products",
      //"url": "https://www.workman.com/shopify/cart/related-products",
      "method": "GET",
      "headers": {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "*",
      },
      "processData": false,
//       "data": JSON.stringify(body)
    "data": "isbns=" + similarItems.attr('data-isbns')
  };

  var items = [];
  var item = {};

  $.ajax(settings).done(function (response) {
   
      $(response).each(function (item) {
          items.push(response[item]);
      });
    
      console.log(items);
    
      data = {
        items: items,
      };
    
    if (items.length > 0) {
      similarItems.append(template(data));
    }
  });
}